export default __webpack_public_path__ + "static/media/Icebreaker-Demo-pic.eeaa1f18.jpg";